var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"ma-0 pa-0",style:(_vm.mapIsLoaded ? 'height: 75vh' : '')},[_c('MapComponent',{ref:"mapComp",staticClass:"ma-0 px-0",attrs:{"gestureHandling":"greedy"},on:{"mapLoaded":_vm.mapLoaded}}),(!_vm.mapIsLoaded)?_c('span',[_vm._v("Map Cannot Load Due to Limited Connectivity")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }